import { IVillageForListPresenterSchema } from '../../../node/repositories/countryside-search/entities/village/VillageForListPresenterSchema';
import { getLocationIds } from './getLocationIds';
import { getVillageBuildingTypes } from './getVillageBuildingTypes';

export const getCustomUrl = (village: IVillageForListPresenterSchema): string => {
  const villageBuildingTypes = getVillageBuildingTypes(village);

  const params: Array<string | undefined | boolean | number> = [];
  const [moId, oblId, cityId] = getLocationIds(village.geo);

  params.push('sale');
  params.push('KP');
  params.push(`mo_id=${moId}`);
  params.push(`obl_id=${oblId}`);
  params.push(`city_id=${cityId}`);
  params.push('object_type=2');
  params.push(`ga_obj_type=${villageBuildingTypes}`);
  params.push('spec=company');
  params.push(village.id);
  params.push('from_developer=1');
  params.push('repres=0');
  params.push('owner=1');
  params.push('pod_snos=1');
  params.push('nv=0');

  return `/${params.filter(Boolean).join('/')}/`;
};
